<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="page_v">
<h2 class="chapternumberh">Contents</h2>
</a><p class="toc1"><a id="page_v"></a><a href="#/foreword"><i>Foreword</i></a></p>
<p class="toc"><a href="#/chapter01">Chapter 1:     My Beloved Kronstadt</a></p>
<p class="toc"><a href="#/chapter02">Chapter 2:     My Youth</a></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">Chapter 3:     Indoctrination on the Eastern Front</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">Chapter 4:     Holland and the Gestapo</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">Chapter 5:     Russia Again</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">Chapter 6:     Best Forgotten</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">Chapter 7:     Rediscovering My Unit!</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">Chapter 8:     Leave!</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">Chapter 9:     Mission—Save or Destroy!</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">Chapter 10:   Treachery</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">Chapter 11:   Eastern Front Retreat</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">Chapter 12:   The Western Front</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">Chapter 13:   Heading East Again!</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">Chapter 14:   “Last of the Mohicans?”</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">Chapter 15:   Prisoner of War</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">Chapter 16:   Freedom!</span></p>
<p class="toc"><span href="#/chapter17" title="Link target outside of Sample">Chapter 17:   “Goodbye, Transylvania”</span></p>
<p class="toc2"><span href="#/epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc1"><span href="#/acknowledgments" title="Link target outside of Sample"><i>Acknowledgments</i></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?18a00db6